import type { ReactNode } from "react"
import { InfoIcon, WarningIcon, XCircleIcon } from "../icons"

const variants = {
  danger: {
    wrapper: "bg-red-50 border-l-4 border-red-500",
    icon: "text-red-400",
    title: "text-red-800",
    link: "text-red-600",
    IconComponent: XCircleIcon,
  },
  warning: {
    wrapper: "bg-orange-50 border-l-4 border-orange-500",
    icon: "text-orange-400",
    title: "text-orange-800",
    link: "text-orange-600",
    IconComponent: WarningIcon,
  },
  info: {
    wrapper: "bg-blue-50 border-l-4 border-blue-500",
    icon: "text-blue-400",
    title: "text-blue-800",
    link: "text-blue-600",
    IconComponent: InfoIcon,
  },
  caution: {
    wrapper: "bg-yellow-50 border-l-4 border-yellow-500",
    icon: "text-yellow-500",
    title: "text-yellow-800",
    link: "text-yellow-600",
    IconComponent: WarningIcon,
  },
}

export function AlertCard({
  variant = "info",
  title,
  action,
}: {
  variant?: keyof typeof variants
  title: string
  action?: ReactNode
}) {
  const v = variants[variant]

  return (
    <div className={`${v.wrapper} p-3 rounded-r shadow-sm`}>
      <div className="flex">
        <div className="flex-shrink-0">
          <v.IconComponent className={`h-4 w-4 ${v.icon}`} />
        </div>
        <div className="ml-2">
          <p className={`text-xs font-semibold ${v.title}`}>{title}</p>
          {action ? (
            <div className={`text-[0.65rem] font-medium underline ${v.link}`}>{action}</div>
          ) : null}
        </div>
      </div>
    </div>
  )
}
